import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './LoginPage.css';

export default function LoginPage() {
   const baseURL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const [empCode, setEmpCode] = useState('');
  const [password, setPassword] = useState('');
  const [Name, setName] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
  e.preventDefault();
  setError('');

  try {
    const res = await axios.post(
      `${baseURL}login`,
      { emp_code: empCode, password: password, comp_name: Name},
      { headers: { "Content-Type": "application/json" } }
    );

    // Successful login
    if (res.data.success) {
      localStorage.setItem('token', res.data.token); // store JWT
      navigate('/dashboard');
    } else {
      setError(res.data.message || "Login failed");
    }
  } catch (err) {
    console.error(err);

    // Show "Invalid credentials" for 401 status
    if (err.response?.status === 401) {
      setError("Invalid credentials");
    } else {
      setError(err.response?.data?.message || 'Login failed');
    }
  }
  };

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleLogin}>
        <h2>Login</h2>

        <div className="input-group">
          <input
            type="text"
            value={empCode}
            onChange={(e) => setEmpCode(e.target.value)}
            required
          />
          <label>Employee Code</label>
        </div>

        <div className="input-group">
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <label>Password</label>
        </div>

        {error && <p className="error">{error}</p>}

        <button type="submit">Login</button>
      </form>
    </div>
  );
}